import React from 'react';
import classNames from 'classnames';

import IgraphValuesLinkedList from 'components/HashrateGraph/IgraphValuesLinkedList';

type ICaption = {
  graphVisibleElements: Array<keyof IgraphValuesLinkedList>,
  toggleGraphVisibleElements: (element: keyof IgraphValuesLinkedList) => void
}

const Caption = ({ graphVisibleElements, toggleGraphVisibleElements }: ICaption) => (
  <div className='caption'>
    <button
      className={classNames({
        item1: true,
        pressed: graphVisibleElements.includes('scoring_hashrate'),
      })}
      onClick={() => {
        toggleGraphVisibleElements('scoring_hashrate');
      }}
    >
    Scoring Hashrate
    </button>
    <button
      className={classNames({
        item2: true,
        pressed: graphVisibleElements.includes('hashrate'),
      })}
      onClick={() => {
        toggleGraphVisibleElements('hashrate');
      }}
    >
    Hashrate
    </button>
    <button
      className={classNames({
        item3: true,
        pressed: graphVisibleElements.includes('workers_active'),
      })}
      onClick={() => {
        toggleGraphVisibleElements('workers_active');
      }}
    >
    Active Workers
    </button>
  </div>
);

export default Caption;
